import { Box, Button, Chip, CircularProgress, Fade, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import RefreshIcon from "@mui/icons-material/Refresh";

const headerSx = {
  borderRadius: 3,
  p: { xs: 2, sm: 3 },
  mb: 0,
  background: "#ffffff",
  border: "1px solid rgba(0,0,0,0.08)",
  borderBottom: "none",
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 2,
};

const HeaderTitle = () => (
  <Box display="flex" alignItems="center" gap={2}>
    <Box
      sx={{
        p: 1.5,
        borderRadius: "50%",
        backgroundColor: "rgba(229, 57, 53, 0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <PauseCircleOutlineIcon sx={{ color: "#E53935", fontSize: 32 }} />
    </Box>
    <Box>
      <Typography variant="h5" fontWeight="bold" color="#1f2937">
        שחרור השהיות סחר
      </Typography>
      <Typography variant="body2" color="#6b7280">
        ניהול הזמנות בסטטוס השהיית סחר
      </Typography>
    </Box>
  </Box>
);

const AutoReleaseButton = ({ previewing, disabled, onClick }) => (
  <Button
    variant="outlined"
    size="small"
    startIcon={previewing ? <CircularProgress size={14} color="inherit" /> : <AutoFixHighIcon />}
    onClick={onClick}
    disabled={previewing || disabled}
    sx={{
      borderColor: "#217346",
      color: "#217346",
      borderRadius: 2,
      fontWeight: 600,
      textTransform: "none",
      "&:hover": { bgcolor: "#f0faf4", borderColor: "#1a5c38" },
    }}
  >
    {previewing ? "סורק..." : "שחרור אוטומטי"}
  </Button>
);

// counts = { total, shown, filtered }; actions only on the orders tab.
const HeaderActions = ({ counts, loading, isSupplier, previewing, onPreview, onRefresh }) => (
  <Box display="flex" alignItems="center" gap={1.5}>
    {!loading && counts.total > 0 && (
      <Chip
        label={counts.filtered ? `${counts.shown} מתוך ${counts.total} הזמנות` : `${counts.total} הזמנות`}
        sx={{ bgcolor: "#ebf7ff", color: "#0054A5", fontWeight: 700 }}
      />
    )}
    {!isSupplier && <AutoReleaseButton previewing={previewing} disabled={loading} onClick={onPreview} />}
    <Tooltip title="רענן">
      <IconButton onClick={onRefresh} disabled={loading} size="small">
        <RefreshIcon />
      </IconButton>
    </Tooltip>
  </Box>
);

const TradeDelayHeader = ({ showActions, ...actionProps }) => (
  <Fade in timeout={600}>
    <Paper elevation={0} sx={headerSx}>
      <HeaderTitle />
      {showActions && <HeaderActions {...actionProps} />}
    </Paper>
  </Fade>
);

export default TradeDelayHeader;
